// import React from 'react';
import * as Common from '../../common'
//export部分
function PdfDocument(props: any) {
  //帳票のヘッダ部分
  const PdfDocumentHeader = (props: any) => {
    /**
     * 帳票のタイトルを出力
     * @returns 帳票のタイトル
     */

    const formTitle = () => {
      if (props.formInfo) {
        if (props.pageType === 'project') {
          //案件一覧のとき
          switch (props.formInfo.status) {
            case 1:
            case 2:
              return '見積書'

            case 3:
            case 4:
              return '受注請書'

            case 5:
              return '請求書'

            case 6:
              return '仮売上請求書'

            default:
              return ''
          }
        } else {
          //購買一覧のとき
          switch (props.formInfo.status) {
            case 1:
            case 2:
            case 3:
              return '発注書'

            case 4:
              return '仕入書'

            default:
              return ''
          }
        }
      } else {
        return ''
      }
    }

    return (
      <div className="pdf-header">
        <div className="pdf-header__inner">
          <div className="pdf-header__ttl">
            <div className="pdf-header__ttl-main">{formTitle()}</div>
            <div className="pdf-header__ttl-num">
              <ul className="pdf-header__list">
                <li className="pdf-header__list-item">
                  <dl className="pdf-header__list-item-inner">
                    <dt className="pdf-header__list-ttl">No.</dt>
                    <dd className="pdf-header__list-no">
                      {props.headerInfo ? props.headerInfo.slip_no : ''}
                    </dd>
                  </dl>
                </li>
                <li className="pdf-header__list-item">
                  <dl className="pdf-header__list-item-inner">
                    <dt className="pdf-header__list-ttl">管 理 番 号</dt>
                    <dd className="pdf-header__list-no">
                      {props.formInfo
                        ? props.formInfo[`${props.pageType}_manage_code`]
                        : ''}
                    </dd>
                  </dl>
                </li>
              </ul>

              {props.meInfo && (
                <div className="pdf-header__company">
                  <div className="pdf-header__company__item">
                    {props.meInfo.m_own_company.company_name_1
                      ? props.meInfo.m_own_company.company_name_1
                      : ''}
                  </div>
                  <div className="pdf-header__company__item">
                    <span className="pdf-header__company__label">〒</span>

                    {props.meInfo.m_own_company.postal_code
                      ? props.meInfo.m_own_company.postal_code
                      : ''}
                  </div>
                  <div className="pdf-header__company__item">
                  {props.meInfo.m_own_company.prefectures_name
                      ? props.meInfo.m_own_company.prefectures_name
                      : ''}
                    {props.meInfo.m_own_company.address_1
                      ? props.meInfo.m_own_company.address_1
                      : ''}
                    {props.meInfo.m_own_company.address_2
                      ? props.meInfo.m_own_company.address_2
                      : ''}
                  </div>
                  <div className="pdf-header__company__item">
                    <span className="pdf-header__company__label">TEL:</span>

                    {props.meInfo.m_own_company.tell_number
                      ? props.meInfo.m_own_company.tell_number
                      : ''}
                  </div>
                  <div className="pdf-header__company__item">
                    <span className="pdf-header__company__label">FAX:</span>

                    {props.meInfo.m_own_company.fax_number
                      ? props.meInfo.m_own_company.fax_number
                      : ''}
                  </div>
                  <div className="pdf-header__company__item">
                    <span className="pdf-header__company__label">担当者:</span>

                    {props.formInfo && props.formInfo.staff_name
                      ? props.formInfo.staff_name
                      : ''}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="pdf-header__middle">
            <div className="pdf-header__info">
              <div className="pdf-header__info-name">
                {props.formInfo ? props.formInfo.supplier_name : ''}　様
              </div>
              <ul className="pdf-header__list">
                <li className="pdf-header__list-item">
                  <dl className="pdf-header__list-item-inner">
                    <dt className="pdf-header__list-ttl">件　　　名</dt>
                    <dd className="pdf-header__list-no">
                      {props.formInfo
                        ? props.formInfo[`${props.pageType}_name`]
                        : ''}
                    </dd>
                  </dl>
                </li>
                <li className="pdf-header__list-item">
                  <dl className="pdf-header__list-item-inner">
                    <dt className="pdf-header__list-ttl">物　件　名</dt>
                    <dd className="pdf-header__list-no">
                      {props.formInfo ? props.formInfo.property_name : ''}
                    </dd>
                  </dl>
                </li>
                <li className="pdf-header__list-item">
                  <dl className="pdf-header__list-item-inner">
                    <dt className="pdf-header__list-ttl">御　担　当</dt>
                    <dd className="pdf-header__list-no">
                      {props.formInfo ? props.formInfo.c_staff_name : ''}
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>

          <div className="pdf-header__price">
            合計金額　￥
            {Number(
              props.headerInfo ? props.headerInfo.total_amount_tax_included : 0,
            ).toLocaleString()}{' '}
            <span style={{ fontSize: '0.7em' }}>(税込)</span>
          </div>
        </div>
      </div>
    )
  }

  //帳票の詳細部分
  const PdfDocumentContent = (props: any) => {
    /**
     * 出力するコンポーネント
     * @returns 出力するコンポーネント
     */
    const contentList = () => {
      /**
       * 帳票に載せる情報
       */
      const infoList = () => {
        if (props.formInfo) {
          if (props.pageType === 'project') {
            // 案件一覧の時
            switch (props.formInfo.status) {
              case 1:
              case 2:
                return props.formInfo.t_project_slip_estimate_details
              case 3:
              case 4:
                return props.formInfo.t_project_slip_sale_details
              case 5:
                return props.formInfo.t_project_slip_invoice_details
              case 6:
                return props.formInfo.t_project_slip_temporary_details
              default:
                return []
            }
          } else {
            // 購買一覧の時
            switch (props.formInfo.status) {
              case 1:
              case 2:
              case 3:
                return props.formInfo.t_purchase_slip_order_details
              case 4:
                return props.formInfo.t_purchase_slip_purchase_details
              default:
                return []
            }
          }
        }
      }

      const headerInfo = () => {
        if (props.formInfo) {
          if (props.pageType === 'project') {
            // 案件一覧の時
            switch (props.formInfo.status) {
              case 1:
              case 2:
                return props.formInfo.t_project_slip_estimate_header
              case 3:
              case 4:
                return props.formInfo.t_project_slip_sale_header
              case 5:
                return props.formInfo.t_project_slip_invoice_header
              case 6:
                return props.formInfo.t_project_slip_temporary_header
              default:
                return []
            }
          } else {
            // 購買一覧の時
            switch (props.formInfo.status) {
              case 1:
              case 2:
              case 3:
                return props.formInfo.t_purchase_slip_order_header
              case 4:
                return props.formInfo.t_purchase_slip_purchase_header
              default:
                return []
            }
          }
        }
      }

      return [
        //パターン１（縦１）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern01">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">品番/規格</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
              <div className="pdf-table__column">備考</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column">{item.standard}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                  <div className="pdf-table__column">{item.remark}</div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column">&nbsp;</div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
          </div>
        </>, //パターン２（縦２）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern02">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">メーカー名</div>
              <div className="pdf-table__column">品番/規格</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column">{item.maker_name}</div>
                  <div className="pdf-table__column">{item.standard}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column">&nbsp;</div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
            </div>
          </div>
        </>, //パターン３（縦３）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern03">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">場所/箇所</div>
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">品番/規格</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column pdf-table__column--include-cell">
                    <div className="pdf-table__cell">{item.event_place}</div>
                    <div className="pdf-table__cell">{item.place}</div>
                  </div>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column">{item.standard}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column pdf-table__column--include-cell">
                <div className="pdf-table__cell">&nbsp;</div>
                <div className="pdf-table__cell">&nbsp;</div>
              </div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
            </div>
          </div>
        </>, //パターン４（縦４）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern04">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">場所/箇所</div>
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
              <div className="pdf-table__column">備考</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column pdf-table__column--include-cell">
                    <div className="pdf-table__cell">{item.event_place}</div>
                    <div className="pdf-table__cell">{item.place}</div>
                  </div>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                  <div className="pdf-table__column">{item.remark}</div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column pdf-table__column--include-cell">
                <div className="pdf-table__cell">&nbsp;</div>
                <div className="pdf-table__cell">&nbsp;</div>
              </div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
          </div>
        </>, //パターン５（横１）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern05">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">場所/箇所</div>
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">品番/規格</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
              <div className="pdf-table__column">備考</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column pdf-table__column--include-cell">
                    <div className="pdf-table__cell">{item.event_place}</div>
                    <div className="pdf-table__cell">{item.place}</div>
                  </div>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column">{item.standard}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                  <div className="pdf-table__column">{item.remark}</div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column pdf-table__column--include-cell">
                <div className="pdf-table__cell">&nbsp;</div>
                <div className="pdf-table__cell">&nbsp;</div>
              </div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
          </div>
        </>, //パターン６（横２）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern06">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">場所/箇所</div>
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">メーカー名</div>
              <div className="pdf-table__column">品番/規格</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
              <div className="pdf-table__column">備考</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column pdf-table__column--include-cell">
                    <div className="pdf-table__cell">{item.event_place}</div>
                    <div className="pdf-table__cell">{item.place}</div>
                  </div>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column">{item.maker_name}</div>
                  <div className="pdf-table__column">{item.standard}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                  <div className="pdf-table__column">{item.remark}</div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column pdf-table__column--include-cell">
                <div className="pdf-table__cell">&nbsp;</div>
                <div className="pdf-table__cell">&nbsp;</div>
              </div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
          </div>
        </>, //パターン７（横３）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern07">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
              <div className="pdf-table__column">備考</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                  <div className="pdf-table__column">{item.remark}</div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column">&nbsp;</div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
          </div>
        </>, //パターン８（横４）
        <>
          <PdfDocumentHeader
            pageType={props.pageType}
            token={props.token}
            formPattern={props.formPattern}
            formInfo={props.formInfo}
            headerInfo={headerInfo()}
            meInfo={props.meInfo}
          ></PdfDocumentHeader>
          <div className="pdf-table pdf-table--pattern08">
            <div className="pdf-table__row pdf-table__row--header">
              <div className="pdf-table__column">品名</div>
              <div className="pdf-table__column">品番/規格</div>
              <div className="pdf-table__column">数量</div>
              <div className="pdf-table__column">単位</div>
              <div className="pdf-table__column">単価</div>
              <div className="pdf-table__column">金額</div>
              <div className="pdf-table__column">備考</div>
            </div>
            {infoList()?.map((item: any, index: number) => {
              return (
                <div className="pdf-table__row" key={index}>
                  <div className="pdf-table__column">{item.product_name}</div>
                  <div className="pdf-table__column">{item.standard}</div>
                  <div className="pdf-table__column cell-value-number">
                    {item.quantity}
                  </div>
                  <div className="pdf-table__column">{item.unit_name}</div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.price).toLocaleString()}
                  </div>
                  <div className="pdf-table__column cell-value-number">
                    {Number(item.amount).toLocaleString()}
                  </div>
                  <div className="pdf-table__column">{item.remark}</div>
                </div>
              )
            })}
            <div className="pdf-table__row pdf-table__row--last">
              <div className="pdf-table__column">&nbsp;</div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【小計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【消費税】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().tax_amount : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
            <div className="pdf-table__row pdf-table__row--prices">
              <div className="pdf-table__column"></div>
              <div className="pdf-table__column">【合計】</div>
              <div className="pdf-table__column">
                {Number(
                  headerInfo() ? headerInfo().total_amount_tax_included : 0,
                ).toLocaleString()}
              </div>
              <div className="pdf-table__column"></div>
            </div>
          </div>
        </>,
      ]
    }
    return contentList()[props.index]
  }

  //コンポーネント部分
  return (
    <div
      id="pdf-content"
      className="pdf"
      style={{
        fontSize:
          [1, 2, 3, 4].indexOf(Number(props.formPattern)) !== -1 ? 16 : 13,
      }}
    >
      <PdfDocumentContent
        pageType={props.pageType}
        token={props.token}
        formPattern={props.formPattern}
        formInfo={props.formInfo}
        index={props.formPattern ? Number(props.formPattern) - 1 : 0}
        meInfo={props.meInfo}
      />
    </div>
  )
}

export default PdfDocument
